import $ from 'jquery';
import Popin from './generic/popin';
import SessionStoragePop from './generic/SessionStoragePop';
import Util from './generic/methodUtils';

const POPIN_PROFILE_DEFAULT_VALUES = {
    MOBILE_BREAKPOINT : 768,
    ACTIV_TEL_HREF_DETAIL: "/swm/swm-ats.html",
    ACTIV_TEL_TEXT_SEE_DETAIL: "Activer mon numéro de téléphone",
    ACTIV_TEL_TEXT_HEADLINE: "Sécurité",
    ACTIV_TEL_TEXT_DESCRIPTION: "Vous avez dû recevoir votre code d'activation par courrier postal. Vous pouvez désormais finaliser l'enregistrement de votre numéro de téléphone.",
    ACTIV_TEL_TEXT_DESCRIPTION_MOBILE: "Vous avez dû recevoir votre code d'activation par courrier postal. Rendez-vous dans votre espace client Internet pour finaliser l'enregistrement de votre numéro de téléphone.",
    RESET_PASSWORD_HREF_DETAIL: "/swm/swm-changemdp.html#etape1",
    RESET_PASSWORD_TEXT_SEE_DETAIL: "Changer le code secret",
    RESET_PASSWORD_TEXT_HEADLINE: "Sécurité",
    SESSION_STORAGE_POPIN_ACTIVATED_TEL_CLOSED: "popin_activate_tel_closed",
    COOKIE_PASSWORD: "nbjexp",
    COOKIE_ACTIVATE_TEL: "CAMPAIGNS",
    VALUE_TO_CHECK_ACTIVATE_TEL_O: "O:ACT",
    VALUE_TO_CHECK_ACTIVATE_TEL_B: "B:ACT",
    PASSWORD_APP: "password",
    DTS_APP: "dts",
    PRIORITY_MOBILE: 1
}

const POPIN_PROFILE_SELECTOR = {
    ID_ZONE : "#js-profil-zone",
    ID_LOGIN_MENU_PROFILE : "js-desktop-profil"
}

export default class PopinProfileApp {

    constructor() {
        var _self = this;

        // init default values
        _self.sessionKey = POPIN_PROFILE_DEFAULT_VALUES.SESSION_STORAGE_POPIN_ACTIVATED_TEL_CLOSED;
        _self.initPropertiesFromConf();
        _self.initMobileContext();

        // init Util Method
        _self.util = new Util();
        // Init session storage with custom key
        _self.sessionStoragePop = new SessionStoragePop(_self.sessionKey);
        // Do not display popin if yet closed during session
        // So do not check the cookie in this context
        if (_self.sessionStoragePop.getJsonObjectFromSession()) {
            _self.needToDisplayActivateTel = false;
        } else {
            _self.needToDisplayActivateTel = _self.checkCookieCampaign();
        }

        _self.popin = new Popin(POPIN_PROFILE_SELECTOR.ID_ZONE, _self.needToDisplayActivateTel ? POPIN_PROFILE_DEFAULT_VALUES.DTS_APP : POPIN_PROFILE_DEFAULT_VALUES.PASSWORD_APP, _self.priorityMobile, true);

        // No popin password in mobile context
        if (_self.onMobile) {
            _self.needToDisplayResetPassword = false;
        } else {
            _self.needToDisplayResetPassword = true;
        }

        // get Cookie for password popin context
        _self.cookieResetPassword = _self.util.getCookie(POPIN_PROFILE_DEFAULT_VALUES.COOKIE_PASSWORD);

        // Event when first element closed
        window.EventBusCMS.addEventListener('popinEvent', event => {
            if (event.detail.firstLvlClosed && event.detail.currentApp === POPIN_PROFILE_DEFAULT_VALUES.DTS_APP) {
                _self.sessionStoragePop.addSimpleBooleanInSessionStorage();
                _self.initPopinResetPassword();
            }
        });
    }

    initMobileContext() {
        // Init Mobile context
        this.onMobile = false;
        if ($(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
            this.onMobile = true;
        }
    }

    initPropertiesFromConf() {
        // Init default URL for phone activation
        if (window.cmsGlobals.popinProfileConfig.url_detail_activ_tel) {
            this.urlDetailActivateTel = window.cmsGlobals.popinProfileConfig.url_detail_activ_tel;
        } else {
            this.urlDetailActivateTel = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_HREF_DETAIL;
        }

        // Init default priority popin on mobile
        this.priorityMobile = POPIN_PROFILE_DEFAULT_VALUES.PRIORITY_MOBILE;

        // Init default URL for password
        if (window.cmsGlobals.popinProfileConfig.url_detail_reset_password) {
            this.urlDetailResetPassword = window.cmsGlobals.popinProfileConfig.url_detail_reset_password;
        } else {
            this.urlDetailResetPassword = POPIN_PROFILE_DEFAULT_VALUES.RESET_PASSWORD_HREF_DETAIL;
        }
    }

    checkCookieCampaign() {
        var _self = this;

        var currentValue = _self.util.getCookie(POPIN_PROFILE_DEFAULT_VALUES.COOKIE_ACTIVATE_TEL);
        if (!currentValue) {
            return false
        }

        try {
            var currentValDecode = JSON.parse(decodeURI(currentValue));
            if (!currentValDecode.DTS) {
                return false;
            }

            if ((currentValDecode.DTS === POPIN_PROFILE_DEFAULT_VALUES.VALUE_TO_CHECK_ACTIVATE_TEL_O)
                || ((currentValDecode.DTS === POPIN_PROFILE_DEFAULT_VALUES.VALUE_TO_CHECK_ACTIVATE_TEL_B))) {
                return true;
            }
        } catch(e) {
           return false;
        }
    }

    /**
     * init activation tel
     */
    initPopinProfile() {
        if (this.needToDisplayActivateTel) {
            this.initPopinActivationTel();
        } else if (this.needToDisplayResetPassword) {
            this.initPopinResetPassword();
        } else if ($(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
            // if no popin - display following popin on mobile
            this.popin.displayNextPopin();
        }
    }

    /**
     * init activation tel
     */
    initPopinActivationTel() {
        var data = {};
        var _self = this;
        _self.popin.hide();

        data.headLine = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_HEADLINE;

        if (_self.onMobile) {
            data.description = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_DESCRIPTION_MOBILE;
        } else {
            data.description = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_DESCRIPTION;
        }

        if (_self.onMobile) {
            data.hideLink = true;
        } else {
            data.textLink = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_SEE_DETAIL;
            data.href = _self.urlDetailActivateTel;
        }

        _self.popin.updatePopinData(data);
        _self.popin.show();
    }

    /**
     * Update popin reset password
     */
    initPopinResetPassword(){
        var _self = this;
        _self.popin.hide();

        if (_self.needToDisplayResetPassword){
            if (_self.cookieResetPassword === "" || Number(_self.cookieResetPassword) > 30) return;
            _self.updatePopinPassword(_self.cookieResetPassword);
            _self.popin.show();
        }
    }

    /**
     * Update notification infobulle
     */
    updatePopinPassword(nbDays) {
        var _self = this;
        var data = {};
        var dayWord = nbDays === "1" ? "jour" : "jours";

        data.href = _self.urlDetailResetPassword;
        data.headLine = POPIN_PROFILE_DEFAULT_VALUES.RESET_PASSWORD_TEXT_HEADLINE;
        data.description = "Vous n'avez pas modifié votre code secret depuis plus d'un an. Il vous reste "+ nbDays + " " + dayWord +" pour le modifier.";
        data.textLink = POPIN_PROFILE_DEFAULT_VALUES.RESET_PASSWORD_TEXT_SEE_DETAIL;

        this.popin.updatePopinData(data);
    }
}



// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/popinProfile.js